import React from 'react';
import { HiLightBulb } from 'react-icons/hi';

const MessageBox = () => {
  return (
    <div className="bg-slate-100 rounded-lg py-1 px-2">
      <ul className="px-8">
        <p className="text-lg flex flex-row  font-semibold text-black capitalize p-0 my-0">
          <HiLightBulb className="text-primary text-2xl pr-1" />
          SunPower Updates
        </p>
        <hr className="my-2" />
        <li className="text-base">
          <strong>Bankruptcy Filing:</strong> SunPower filed for Chapter 11
          bankruptcy August 5th 2024 due to financial difficulties, signalling
          severe challenges for the company.
        </li>
        <li className="text-base">
          <strong>Asset Sales:</strong> They are selling key assets to Complete
          Solaria, including Blue Raven Solar and parts of their dealer network,
          as part of the restructuring process.
        </li>
        <li className="text-base">
          <strong>Operations Paused:</strong> Key operations were halted before
          the bankruptcy filing, indicating deeper issues within the company.
        </li>
      </ul>
    </div>
  );
};

export default MessageBox;
